import styled from 'styled-components'
import { ColorVariant, getColorVariantColor } from './GlobalStyles'

type BaseProps = {
  colorVariant?: ColorVariant
  capitalize?: boolean
  align?: 'left' | 'center' | 'right'
  uppercase?: boolean
  bold?: boolean
  semibold?: boolean
  hexColor?: string
  mb?: string
  mt?: string
  ml?: string
  mr?: string
  m?: string
  pointer?: boolean
  hoverUnderline?: boolean
}

const Base = styled.div<BaseProps>`
  font-size: 16px;
  font-weight: ${({ bold, semibold }) => (bold ? 700 : semibold ? 500 : 400)};
  width: fit-content;
  color: ${({ theme, colorVariant, hexColor }) =>
    hexColor ? hexColor : getColorVariantColor(colorVariant, theme)};
  text-transform: ${({ capitalize, uppercase }) =>
    capitalize ? 'capitalize' : uppercase ? 'uppercase' : 'none'};
  text-align: ${({ align }) => (align ? align : 'left')};
  margin: ${({ m }) => (m ? m : '0')};
  margin-bottom: ${({ mb }) => (mb ? mb : '0')};
  margin-top: ${({ mt }) => (mt ? mt : '0')};
  margin-left: ${({ ml }) => (ml ? ml : '0')};
  margin-right: ${({ mr }) => (mr ? mr : '0')};
  cursor: ${({ pointer }) => (pointer ? 'pointer' : 'default')};

  ${({ hoverUnderline }) => hoverUnderline && '&:hover { text-decoration: underline; }'}

  a {
    text-decoration: none;
    color: inherit;
  }
`

const Heading1 = styled(Base)`
  font-size: 24px;
  font-weight: 700;
`

const Heading2 = styled(Base)`
  font-size: 18px;
  font-weight: 700;
`

const BigText = styled(Base)`
  font-size: 18px;
`

const NormalText = styled(Base)`
  font-size: 16px;
`

const MediumText = styled(Base)`
  font-size: 14px;
`

const SmallText = styled(Base)`
  font-size: 12px;
`

const TinyText = styled(Base)`
  font-size: 10px;
`

export { Heading1, Heading2, NormalText, SmallText, MediumText, TinyText, BigText, ColorVariant }
